import { DropdownOptions } from '@components/common/formControl/dropdown';
import { OTHERS_SPECIFY, phoneRegExp } from '@config/constant';
import { convertTo24Hour, RoleType } from '@helper/utils';
import * as Yup from 'yup';
import {
	contractorNameValidation,
	dealerVisitProductsValidationSchema,
	meetingClubValidationSchema,
	meetingMdpClubValidationSchema,
} from './utils';
import { SiteLeadConfigurations } from '@components/siteLeads';
import { NumberNullUndefinedUnionType, StringNullUndefinedUnionType } from '@helper/commonTypesAlias';
import { useEndUserProfileStore } from '@store/endUserProfileStore';
import {
	IRBDMAddMeetingFormInitialValues,
	IsLcdWiseUserMeet,
	LCD_MEETS_SHOP_HALL,
	MEETING_HIDE_FOCUS_PRODUCT,
	SocialMeetType,
	START_DATE_RESTRICTION_MEET,
} from '@components/meetingModule/components/addNewMeeting';
import { SiteTypeLabel } from '@components/lms/addNewSite/components/siteInformation';
import { GlueUsedLabel } from '@components/lms/addNewSite/components/glueDetails';
import { linkCaptureVideosMeet } from '@components/todayMeetingDetails';

type FeedbackResponseType = string | number | boolean | { [key: string]: string } | undefined;

export interface IValidationFields {
	primary_number: Yup.StringSchema<StringNullUndefinedUnionType>;
	secondary_number: Yup.StringSchema<StringNullUndefinedUnionType>;
	sites_worked: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	sites_competition: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	average_glue: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	competitionConsumption: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	calculated_glue: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	permanent_town: Yup.StringSchema<StringNullUndefinedUnionType>;
	permanent_address: Yup.StringSchema<StringNullUndefinedUnionType>;
	permanent_zipcode: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	permanent_street: Yup.StringSchema<StringNullUndefinedUnionType>;
	permanent_city: Yup.StringSchema<StringNullUndefinedUnionType>;
	permanent_state: Yup.StringSchema<StringNullUndefinedUnionType>;
	local_address: Yup.StringSchema<StringNullUndefinedUnionType>;
	local_zipcode: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	local_street: Yup.StringSchema<StringNullUndefinedUnionType>;
	local_city: Yup.StringSchema<StringNullUndefinedUnionType>;
	local_state: Yup.StringSchema<StringNullUndefinedUnionType>;
	work_address: Yup.StringSchema<StringNullUndefinedUnionType>;
	work_zipcode: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	work_street: Yup.StringSchema<StringNullUndefinedUnionType>;
	work_city: Yup.StringSchema<StringNullUndefinedUnionType>;
	work_state: Yup.StringSchema<StringNullUndefinedUnionType>;
	document: Yup.StringSchema<StringNullUndefinedUnionType>;
	document_number: Yup.StringSchema<StringNullUndefinedUnionType>;
	club: Yup.StringSchema<StringNullUndefinedUnionType>;
	secondary_club: Yup.StringSchema<StringNullUndefinedUnionType>;
	average_glue_potential: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	no_of_carpenters: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	contractor_aid: Yup.StringSchema<StringNullUndefinedUnionType>;
	workshop_zipcode: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	workshop_address: Yup.StringSchema<StringNullUndefinedUnionType>;
	workshop_city: Yup.StringSchema<StringNullUndefinedUnionType>;
	workshop_street: Yup.StringSchema<StringNullUndefinedUnionType>;
	workshop_state: Yup.StringSchema<StringNullUndefinedUnionType>;
	factory_zipcode: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	factory_address: Yup.StringSchema<StringNullUndefinedUnionType>;
	factory_city: Yup.StringSchema<StringNullUndefinedUnionType>;
	factory_state: Yup.StringSchema<StringNullUndefinedUnionType>;
	siteName: Yup.StringSchema<StringNullUndefinedUnionType>;
	siteLocation: Yup.StringSchema<StringNullUndefinedUnionType>;
	gradeUsed: Yup.StringSchema<StringNullUndefinedUnionType>;
	contractType: Yup.StringSchema<StringNullUndefinedUnionType>;
	competitionReason: Yup.StringSchema<StringNullUndefinedUnionType>;
	secondaryCompetitionReason: Yup.ArraySchema<
		{
			id: number;
			value: string;
		}[],
		Yup.AnyObject,
		'',
		''
	>;
	secondaryCompetitionReasonOther: Yup.StringSchema<StringNullUndefinedUnionType>;
	contractorName: Yup.StringSchema<StringNullUndefinedUnionType>;
	contractorNumber: Yup.StringSchema<StringNullUndefinedUnionType>;
	dealerName: Yup.StringSchema<StringNullUndefinedUnionType>;
	gluePotentialOfSite: Yup.StringSchema<StringNullUndefinedUnionType>;
	kyc_file_name: Yup.StringSchema<StringNullUndefinedUnionType>;

	name: Yup.StringSchema<StringNullUndefinedUnionType>;
	contact: Yup.StringSchema<StringNullUndefinedUnionType>;
	town: Yup.StringSchema<StringNullUndefinedUnionType>;
	meetingVenue: Yup.StringSchema<StringNullUndefinedUnionType>;
	meetingTheme: Yup.StringSchema<StringNullUndefinedUnionType>;
	meetingType: Yup.StringSchema<StringNullUndefinedUnionType>;
	mdi: Yup.StringSchema<StringNullUndefinedUnionType>;
	primaryFocusProduct: Yup.StringSchema<StringNullUndefinedUnionType>;
	productDiscussed: Yup.StringSchema<StringNullUndefinedUnionType>;
	meetFormat: Yup.StringSchema<StringNullUndefinedUnionType>;
	participants: Yup.StringSchema<StringNullUndefinedUnionType>;
	productHierarchyCode: Yup.StringSchema<StringNullUndefinedUnionType>;
	catagories: Yup.StringSchema<StringNullUndefinedUnionType>;
	designation: Yup.StringSchema<StringNullUndefinedUnionType>;
	natureOfWork: Yup.StringSchema<StringNullUndefinedUnionType>;
	userToBeLinked: Yup.StringSchema<StringNullUndefinedUnionType>;
	obstacleFaced: Yup.StringSchema<StringNullUndefinedUnionType>;
	learningForm: Yup.StringSchema<StringNullUndefinedUnionType>;
	meeting_expenses: Yup.StringSchema<StringNullUndefinedUnionType>;
	food: Yup.StringSchema<StringNullUndefinedUnionType>;
	venue: Yup.StringSchema<StringNullUndefinedUnionType>;
	gifts: Yup.StringSchema<StringNullUndefinedUnionType>;
	others: Yup.StringSchema<StringNullUndefinedUnionType>;
	sku_names_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	ref_lot_no_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	manufactured_in_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	quantity_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	customer_name_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	registered_mobile_number_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	type_of_complaint_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	dealer_membership_code_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	wss_names_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	site_under_warranty_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	what_is_the_warranty_certificate_number_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	nature_of_complaints_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	sub_category_defect_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	description_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	pictures_videos_c: Yup.ArraySchema<string[], Yup.AnyObject, undefined>;
	complaint_sample_availability_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	sample_non_availability_reason: Yup.StringSchema<StringNullUndefinedUnionType>;
	sample_non_availability_reason_others: Yup.StringSchema<StringNullUndefinedUnionType>;

	applicator_name: Yup.StringSchema<StringNullUndefinedUnionType>;
	stage_of_application_during_complaint_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	application_surface_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	area_in_sqft_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	observation_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	glueUsedAtSite: Yup.StringSchema<StringNullUndefinedUnionType>;

	primary_details: Yup.ArraySchema<
		| {
				id?: number;
				dealer_code: string;
				dealer_name: string;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	competition_details: Yup.ArraySchema<
		| {
				id?: number;
				competition_brands: string;
				other_competition_brands: string;
				competition_volume: number;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	title: Yup.StringSchema<StringNullUndefinedUnionType>;
	meeting_venue_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	startdate: Yup.DateSchema<Date | null | undefined>;
	enddate: Yup.DateSchema<Date | null | undefined>;
	start_time_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	end_time_c: Yup.StringSchema<StringNullUndefinedUnionType>;
	electionNominationEndDate: Yup.DateSchema<Date | null | undefined>;
	electionNominationEndTime: Yup.StringSchema<StringNullUndefinedUnionType>;
	slab: Yup.StringSchema<StringNullUndefinedUnionType>;
	productRSI: Yup.ArraySchema<
		| {
				id: number;
				value: string;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	activityDiscussed: Yup.ArraySchema<
		| {
				id: number;
				value: string;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	address: Yup.StringSchema<StringNullUndefinedUnionType>;
	contractorName1: Yup.StringSchema<StringNullUndefinedUnionType>;
	contractorName2: Yup.StringSchema<StringNullUndefinedUnionType>;
	contractorNumber1: Yup.StringSchema<StringNullUndefinedUnionType>;
	contractorNumber2: Yup.StringSchema<StringNullUndefinedUnionType>;
	architect_details: Yup.ArraySchema<
		| {
				number?: string | null;
				id?: number;
				name?: string | null;
				isActive?: boolean;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	influencer_details: Yup.ArraySchema<
		| {
				number?: string | null;
				id?: number;
				name?: string | null;
				isActive?: boolean;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	owner_details: Yup.ArraySchema<
		| {
				number?: string | null;
				id?: number;
				name?: string | null;
				isActive?: boolean;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	feedback: Yup.ArraySchema<
		| (
				| {
						feedbackResponse?: FeedbackResponseType;
				  }[]
				| undefined
		  )[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	exception: Yup.ArraySchema<
		| {
				id?: number;
				productId?: number;
				feedbackQuestion?: string;
				feedbackOptions?: {
					id?: number;
					value?: string;
				}[];
				type?: string;
				placeHolder?: string;
				feedbackResponse: string;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	isContractorAvailable: Yup.StringSchema<string | null | undefined>;
	isWeatherWorkGivenToJoinery: Yup.StringSchema<StringNullUndefinedUnionType>;
	joineryName: Yup.StringSchema<StringNullUndefinedUnionType>;
	joineryNumber: Yup.StringSchema<StringNullUndefinedUnionType>;
	joineryAddress: Yup.StringSchema<StringNullUndefinedUnionType>;
	isWorkGivenToFactory: Yup.StringSchema<StringNullUndefinedUnionType>;
	siteAddressFactoryName: Yup.StringSchema<StringNullUndefinedUnionType>;
	siteAddressFactoryNumber: Yup.StringSchema<StringNullUndefinedUnionType>;
	siteAddressFactoryAddress: Yup.StringSchema<StringNullUndefinedUnionType>;
	substratesCombinations: Yup.ArraySchema<
		{
			id: number;
			value: string;
		}[],
		Yup.AnyObject,
		'',
		''
	>;
	meetingClub: Yup.ArraySchema<
		| {
				id: string;
				value: string;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	meetingDealer: Yup.StringSchema;
	factoryName: Yup.StringSchema;
	factoryLocation: Yup.StringSchema;
	brandNoticed: Yup.StringSchema;
	brand: Yup.StringSchema;
	chargeToVisitContractor: Yup.StringSchema;
	brandOthers: Yup.StringSchema;
	factory_visit_feedback: Yup.StringSchema;
	siteSpecialist: Yup.StringSchema;
	superVisorNumber: Yup.StringSchema<StringNullUndefinedUnionType>;
	superVisorName: Yup.StringSchema<StringNullUndefinedUnionType>;
	superVisorNumberRequired: Yup.StringSchema<StringNullUndefinedUnionType>;
	superVisorNameRequired: Yup.StringSchema<StringNullUndefinedUnionType>;
	competitionGlueUsedSoFar: Yup.StringSchema;
	fvGlueUsedSoFar: Yup.StringSchema;
	noOfActiveSites: Yup.StringSchema;
	availableOtherProductsDemoed: Yup.ArraySchema<
		{
			id: number;
			value: string;
		}[],
		Yup.AnyObject,
		'',
		''
	>;
	availableOtherProductsDiscussed: Yup.ArraySchema<
		{
			id: number;
			value: string;
		}[],
		Yup.AnyObject,
		'',
		''
	>;
	RBDMAddMeetingValidationSchema: Yup.ObjectSchema<IRBDMAddMeetingFormInitialValues>;
	siteType: Yup.StringSchema<StringNullUndefinedUnionType>;
	typeOfProperty: Yup.StringSchema<StringNullUndefinedUnionType>;
	propertyArea: Yup.StringSchema<StringNullUndefinedUnionType>;
	siteStage: Yup.StringSchema<StringNullUndefinedUnionType>;
	brandAvailable: Yup.StringSchema<StringNullUndefinedUnionType>;
	glueUsedSoFar: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	conversionPotential: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	siteSubStage: Yup.StringSchema<StringNullUndefinedUnionType>;
	tentativeNextVisit: Yup.DateSchema<Date | null | undefined>;
	glueConsumed: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	additionalCompetitionBrand: Yup.StringSchema<StringNullUndefinedUnionType>;
	personAtSite: Yup.StringSchema<StringNullUndefinedUnionType>;
	reasonForCompetition: Yup.StringSchema<StringNullUndefinedUnionType>;
	personConvince: Yup.StringSchema<StringNullUndefinedUnionType>;
	followUpDate: Yup.DateSchema<Date | null | undefined>;
	productDemo: Yup.StringSchema<StringNullUndefinedUnionType>;
	unsuccessfulDemoReason: Yup.StringSchema<StringNullUndefinedUnionType>;
	conversionVolume: Yup.NumberSchema<number | null | undefined>;
	fevicolProduct: Yup.ArraySchema<string[] | undefined, Yup.AnyObject, undefined, ''>;
	totalConversionVolume: Yup.NumberSchema<number | null | undefined>;
	noOfSites: Yup.StringSchema<StringNullUndefinedUnionType>;
	contractorPotentialPerMonth: Yup.StringSchema<StringNullUndefinedUnionType>;
	assigneCmdi: Yup.StringSchema<StringNullUndefinedUnionType>;
	followUpReason: Yup.StringSchema<StringNullUndefinedUnionType>;
	followUpDateForVisit3Plus: Yup.DateSchema<Date | null | undefined>;
	otherBrandName: Yup.StringSchema<StringNullUndefinedUnionType>;
	productComplaintLast1Month: Yup.StringSchema<StringNullUndefinedUnionType>;
	customProductComplaintDescription: Yup.StringSchema<StringNullUndefinedUnionType>;
	complaintProductsList: Yup.ArraySchema<
		| {
				id: number;
				value: string;
		  }[]
		| undefined,
		Yup.AnyObject,
		undefined,
		''
	>;
	productComplaintDescription: Yup.ArraySchema<
		| {
				id: number;
				value: string;
		  }[]
		| undefined,
		Yup.AnyObject,
		undefined,
		''
	>;
	meetSubCategory: Yup.ArraySchema<
		{
			id: number;
			value: string;
		}[],
		Yup.AnyObject,
		'',
		''
	>;
	meetingPhotos: Yup.ArraySchema<string[] | undefined, Yup.AnyObject, undefined, ''>;
	primaryFocusProductLcdMeets: Yup.ArraySchema<
		{
			id: number;
			value: string;
		}[],
		Yup.AnyObject,
		undefined,
		''
	>;
	brandUsed: Yup.StringSchema<StringNullUndefinedUnionType>;
	meetingMdpClub: Yup.ArraySchema<
		| {
				id: string;
				value: string;
		  }[]
		| undefined,
		Yup.AnyObject,
		'',
		''
	>;
	workshop_checkbox: Yup.StringSchema<StringNullUndefinedUnionType>;
	factory_checkbox: Yup.StringSchema<StringNullUndefinedUnionType>;
	interior_work: Yup.StringSchema<StringNullUndefinedUnionType>;
	what_kind_of_jobs_do_you_undertake: Yup.StringSchema<StringNullUndefinedUnionType>;
	work_do_you_generally_undertake: Yup.StringSchema<StringNullUndefinedUnionType>;
	monthlyaverageconsumptionfhi_c: Yup.NumberSchema<NumberNullUndefinedUnionType>;
	enable_carpenter_option: Yup.StringSchema<StringNullUndefinedUnionType>;
	boss_name: Yup.StringSchema<StringNullUndefinedUnionType>;
	boss_mobile: Yup.StringSchema<StringNullUndefinedUnionType>;
}

const substratesValidationSchema = Yup.array()
	.of(
		Yup.object().shape({
			id: Yup.number().required('ID is required'),
			value: Yup.string().required('Value is required'),
		})
	)
	.min(1, 'Are any of the below substrates combinations being used at site is required')
	.required('Are any of the below substrates combinations being used at site is required');

const availableOtherProductsDemoValidationSchema = Yup.array()
	.of(
		Yup.object().shape({
			id: Yup.number().required('ID is required'),
			value: Yup.string().required('Value is required'),
		})
	)
	.min(1, 'Other Products Demoed is required')
	.required('Other Products Demoed is required');

const availableOtherProductsDiscussValidationSchema = Yup.array()
	.of(
		Yup.object().shape({
			id: Yup.number().required('ID is required'),
			value: Yup.string().required('Value is required'),
		})
	)
	.min(1, 'Other Products Discussed is required')
	.required('Other Products Discussed is required');

const dealerSchema = Yup.object().shape({
	id: Yup.number(),
	dealer_code: Yup.string().required('Dealer Code is required'),
	dealer_name: Yup.string().required('Dealer Name is required'),
});
const competitionSchema = Yup.object().shape({
	id: Yup.number(),
	competition_brands: Yup.string().required('Competition Brand is required'),
	other_competition_brands: Yup.string().when('competition_brands', {
		is: (competitionBrands: string) => competitionBrands?.includes('Others'),
		then: (schema) => schema.required('Other Competition Brand is required'),
		otherwise: (schema) => schema.notRequired(),
	}),
	competition_volume: Yup.number().required('Competition Volume is required'),
});

const accordianSchema = Yup.object().shape({
	id: Yup.number(),
	isActive: Yup.boolean(),
	name: Yup.string()
		.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed in the name')
		.nullable(),

	number: Yup.string().matches(phoneRegExp, 'Number is not valid').nullable(),
});

const useValidationFields = (): IValidationFields => {
	const rbdmTown = Yup.string().required('RBDM Town is required');
	const { upperFormRevalidateFiled, moreDetailFormRevalidateField } = useEndUserProfileStore();
	const primary_number = Yup.string()
		.matches(phoneRegExp, 'Phone number is not valid')
		.required('Primary Number is Required')
		.nullable();
	const secondary_number = Yup.string()
		.matches(phoneRegExp, 'Phone number is not valid')
		.test('not-same-as-primary', 'Secondary number should not be the same as Primary Number', function (value) {
			const primary = this.parent.primary_number;
			if (primary && value) {
				return primary !== value;
			}
			return true;
		})
		.nullable();

	const sites_worked = Yup.number()
		.required('How many sites have you worked on in the last 6 months is required')
		.nullable()
		.min(0, 'Value must be positive number');
	const sites_competition = Yup.number()
		.min(0, 'Value must be a positive number')
		.required('How many sites did you have to use competition is required')
		.nullable()
		.test('max-sites-comp', 'No of competition sites cannot be greater than total no of sites', function (value) {
			const { sites_worked } = this.parent;
			return value == null || sites_worked == null || value <= sites_worked;
		});
	const average_glue = Yup.number()
		.min(0, 'Value must be positive number')
		.required('Glue consumption per month is required')
		.test('retyped', 'Please revalidate glue consumption per month', (): boolean => {
			return upperFormRevalidateFiled.average_glue;
		});
	const competitionConsumption = Yup.number()
		.min(0, 'Value must be a positive number')
		.required('Monthly Competition Consumption is required')
		.nullable()
		.test('max-avg-glue', 'Monthly competition consumption cannot be greater than average glue', function (value) {
			const { average_glue } = this.parent;
			return value == null || sites_worked == null || value <= average_glue;
		})
		.test('retyped', 'Please revalidate monthly competition consumption', (): boolean => {
			return upperFormRevalidateFiled.competitionConsumption;
		});
	const monthlyaverageconsumptionfhi_c = Yup.number()
		.min(0, 'Value must be positive number')
		.required('FBK Potential is required');
	const calculated_glue = Yup.number().min(0, 'Value must be positive number').nullable();
	const permanent_town = Yup.string().required('Town is required');
	const permanent_address = Yup.string().required('Permanent Address required').nullable();
	const permanent_zipcode = Yup.number().required('Zip code is required');
	const permanent_street = Yup.string().required('Street required').nullable();
	const permanent_city = Yup.string().required('City required').nullable();
	const permanent_state = Yup.string().required('State required').nullable();

	const local_address = Yup.string().when('local_address_chekbox', {
		is: false,
		then: () => Yup.string().required('Local Address is required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});

	const local_zipcode = Yup.number().when('local_address_chekbox', {
		is: false,
		then: () => Yup.number().required('Zip code is required').nullable(),
		otherwise: () => Yup.number().nullable(),
	});

	const local_street = Yup.string().when('local_address_chekbox', {
		is: false,
		then: () => Yup.string().required('Street is required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});

	const local_city = Yup.string().when('local_address_chekbox', {
		is: false,
		then: () => Yup.string().required('City is required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});

	const local_state = Yup.string().when('local_address_chekbox', {
		is: false,
		then: () => Yup.string().required('State is required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});

	const work_address = Yup.string().when('work_address_chekbox', {
		is: false,
		then: () => Yup.string().required('Work Address is required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});

	const work_zipcode = Yup.number().when('work_address_chekbox', {
		is: false,
		then: () => Yup.number().required('Zip code is required').nullable(),
		otherwise: () => Yup.number().nullable(),
	});

	const work_street = Yup.string().when('work_address_chekbox', {
		is: false,
		then: () => Yup.string().required('Street is required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});

	const work_city = Yup.string().when('work_address_chekbox', {
		is: false,
		then: () => Yup.string().required('City is required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});

	const work_state = Yup.string().when('work_address_chekbox', {
		is: false,
		then: () => Yup.string().required('State is required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});
	const document = Yup.string().nullable();
	const document_number = Yup.string().nullable();
	const club = Yup.string().required('Club is Required');
	const secondary_club = Yup.string().when('role', ([role], schema) => {
		if (role === RoleType.KAE) {
			return schema.required('BDE Club is Required');
		}

		return schema.notRequired();
	});
	const primary_details = Yup.array().of(dealerSchema);
	const competition_details = Yup.array().of(competitionSchema);
	const average_glue_potential = Yup.number().nullable();
	const no_of_carpenters = Yup.number().when('role', {
		is: RoleType.KAE,
		then: (schema) => schema.required('No. of carpenters is required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const workshop_checkbox = Yup.string().when('role', {
		is: RoleType.KAE,
		then: (schema) => schema.required('Workshop selection is Required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const factory_checkbox = Yup.string().when('role', {
		is: RoleType.KAE,
		then: (schema) => schema.required('Factory selection is Required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const what_kind_of_jobs_do_you_undertake = Yup.string().when('workshop_checkbox', {
		is: 'No',
		then: () => Yup.string().required('Do you get job work is Required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});
	const work_do_you_generally_undertake = Yup.string().when('factory_checkbox', {
		is: 'No',
		then: () => Yup.string().required('Do you get job work is Required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});
	const interior_work = Yup.string().when('role', {
		is: RoleType.KAE,
		then: (schema) => schema.required('Interior Work selection is Required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const enable_carpenter_option = Yup.string().when('role', {
		is: (role: string) => role !== RoleType.SS,
		then: (schema) => schema.required().nullable(),
		otherwise: (schema) => schema.notRequired().nullable(),
	});
	const boss_name = Yup.string().when(['enable_carpenter_option', 'role'], {
		is: (enableCarpenterOption: string, role: string) => enableCarpenterOption === 'Yes' && role !== RoleType.SS,
		then: (schema) =>
			schema
				.required("Carpenter's Boss Name is required")
				.max(50, "Carpenter's Boss Name cannot exceed 50 characters")
				.nullable(),
		otherwise: (schema) => schema.notRequired().nullable(),
	});
	const boss_mobile = Yup.string().when(['enable_carpenter_option', 'role'], {
		is: (enableCarpenterOption: string, role: string) => enableCarpenterOption === 'Yes' && role !== RoleType.SS,
		then: (schema) =>
			schema
				.required("Carpenter's Boss Mobile Number is required")
				.matches(phoneRegExp, 'Enter valid 10 digit mobile number')
				.nullable(),
		otherwise: (schema) => schema.notRequired().nullable(),
	});
	const contractor_aid = Yup.string().required('Aid is required');
	const workshop_address = Yup.string().when(['workshop_checkbox', 'what_kind_of_jobs_do_you_undertake'], {
		is: (workshop_checkbox: string | boolean, what_kind_of_jobs: string) => {
			return workshop_checkbox === 'true' || workshop_checkbox === 'Yes' || what_kind_of_jobs === 'Yes';
		},
		then: () =>
			Yup.string()
				.required('Workshop Address is Required')
				.test('retyped', 'Please revalidate workshop address', (): boolean => {
					return moreDetailFormRevalidateField.workshop_address;
				}),
		otherwise: () => Yup.string().required('Workshop Address is Required').nullable(),
	});
	const workshop_zipcode = Yup.number().when(['workshop_checkbox', 'what_kind_of_jobs_do_you_undertake'], {
		is: (workshop_checkbox: string | boolean, what_kind_of_jobs: string) =>
			workshop_checkbox === 'true' || workshop_checkbox === 'Yes' || what_kind_of_jobs === 'Yes',
		then: () =>
			Yup.number()
				.required('Zipcode is Required')
				.test('retyped', 'Please revalidate workshop zipcode', (): boolean => {
					return moreDetailFormRevalidateField.workshop_zipcode;
				}),
		otherwise: () => Yup.number().nullable(),
	});

	const workshop_city = Yup.string().when(['workshop_checkbox', 'what_kind_of_jobs_do_you_undertake'], {
		is: (workshop_checkbox: string | boolean, what_kind_of_jobs: string) =>
			workshop_checkbox === 'true' || workshop_checkbox === 'Yes' || what_kind_of_jobs === 'Yes',
		then: () =>
			Yup.string()
				.required('City is Required')
				.test('retyped', 'Please revalidate workshop city', (): boolean => {
					return moreDetailFormRevalidateField.workshop_city;
				}),
		otherwise: () => Yup.string().nullable(),
	});

	const workshop_street = Yup.string().when(['workshop_checkbox', 'what_kind_of_jobs_do_you_undertake'], {
		is: (workshop_checkbox: string | boolean, what_kind_of_jobs: string) =>
			workshop_checkbox === 'true' || workshop_checkbox === 'Yes' || what_kind_of_jobs === 'Yes',
		then: () =>
			Yup.string()
				.required('Street is Required')
				.test('retyped', 'Please revalidate workshop street', (): boolean => {
					return moreDetailFormRevalidateField.workshop_street;
				}),
		otherwise: () => Yup.string().nullable(),
	});

	const workshop_state = Yup.string().when(['workshop_checkbox', 'what_kind_of_jobs_do_you_undertake'], {
		is: (workshop_checkbox: string | boolean, what_kind_of_jobs: string) =>
			workshop_checkbox === 'true' || workshop_checkbox === 'Yes' || what_kind_of_jobs === 'Yes',
		then: () =>
			Yup.string()
				.required('State is Required')
				.test('retyped', 'Please revalidate workshop state', (): boolean => {
					return moreDetailFormRevalidateField.workshop_state;
				}),
		otherwise: () => Yup.string().nullable(),
	});
	const factory_address = Yup.string().when(['factory_checkbox', 'work_do_you_generally_undertake'], {
		is: (factory_checkbox: string | boolean, work_do_you_generally_undertake: string) =>
			factory_checkbox === 'true' || factory_checkbox === 'Yes' || work_do_you_generally_undertake === 'Yes',
		then: () =>
			Yup.string()
				.required('State is Required')
				.test('retyped', 'Please revalidate workshop state', (): boolean => {
					return moreDetailFormRevalidateField.workshop_state;
				}),
		otherwise: () => Yup.string().nullable(),
	});
	const factory_zipcode = Yup.number().when(['factory_checkbox', 'work_do_you_generally_undertake'], {
		is: (factory_checkbox: string | boolean, work_do_you_generally_undertake: string) =>
			factory_checkbox === 'true' || factory_checkbox === 'Yes' || work_do_you_generally_undertake === 'Yes',
		then: () =>
			Yup.number()
				.required('Zipcode is Required')
				.test('retyped', 'Please revalidate factory zipcode', (): boolean => {
					return moreDetailFormRevalidateField.factory_zipcode;
				}),
		otherwise: () => Yup.number().nullable(),
	});

	const factory_city = Yup.string().when(['factory_checkbox', 'work_do_you_generally_undertake'], {
		is: (factory_checkbox: string | boolean, work_do_you_generally_undertake: string) =>
			factory_checkbox === 'true' || factory_checkbox === 'Yes' || work_do_you_generally_undertake === 'Yes',
		then: () =>
			Yup.string()
				.required('City is Required')
				.test('retyped', 'Please revalidate factory city', (): boolean => {
					return moreDetailFormRevalidateField.factory_city;
				}),
		otherwise: () => Yup.string().nullable(),
	});

	const factory_state = Yup.string().when(['factory_checkbox', 'work_do_you_generally_undertake'], {
		is: (factory_checkbox: string | boolean, work_do_you_generally_undertake: string) =>
			factory_checkbox === 'true' || factory_checkbox === 'Yes' || work_do_you_generally_undertake === 'Yes',
		then: () =>
			Yup.string()
				.required('State is Required')
				.test('retyped', 'Please revalidate factory state', (): boolean => {
					return moreDetailFormRevalidateField.factory_state;
				}),
		otherwise: () => Yup.string().nullable(),
	});

	const title = Yup.string().required('Title is required').max(30, 'Title should no be more than 30 characters');
	const meeting_venue_c = Yup.string()
		.trim()
		.required('Venue is required')
		.max(50, 'Venue should no be more than 50 characters');
	const today = new Date();
	today.setHours(0, 0, 0, 0);
	const getMinimumMeetingDate = (): Date => {
		const today = new Date();
		today.setHours(0, 0, 0, 0);

		const minimumDate = new Date(today);
		minimumDate.setDate(today.getDate() + 5);

		return minimumDate;
	};

	const startdate = Yup.date().when('meetingType', {
		is: (val: string) => val === START_DATE_RESTRICTION_MEET,
		then: (schema) =>
			schema
				.required('Start date is required')
				.min(getMinimumMeetingDate(), 'Start date must be on or after 5 days from the current date'),
		otherwise: (schema) =>
			schema.required('Start date is required').min(today, 'Start date must be today or in the future'),
	});

	const enddate = Yup.date()
		.required('End date is required')
		.test('is-valid-range', 'End date must be the same or later than start date', function (value) {
			const { startdate } = this.parent;
			if (startdate && value) {
				const start = new Date(startdate);
				const end = new Date(value);

				start.setHours(0, 0, 0, 0);
				end.setHours(0, 0, 0, 0);

				return end >= start;
			}
			return true;
		})
		.test('is-within-5-days', 'You can create meetings for up to 5 days only', function (value) {
			const { startdate } = this.parent;
			if (startdate && value) {
				const start = new Date(startdate);
				const end = new Date(value);

				start.setHours(0, 0, 0, 0);
				end.setHours(0, 0, 0, 0);

				const diffTime = end.getTime() - start.getTime();
				const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

				return diffDays <= 5;
			}
			return true;
		});
	const start_time_c = Yup.string().required('Start time is required');
	const end_time_c = Yup.string()
		.trim()
		.required('End time is required')
		.test('is-at-least-one-hour-later', 'End time must be at least one hour later than start time', function (value) {
			const { startdate, enddate, start_time_c } = this.parent;
			if (!startdate || !enddate || !start_time_c || !value) {
				return true;
			}
			const startDate = new Date(startdate);
			const endDate = new Date(enddate);
			const [startHour, startMinute] = convertTo24Hour(start_time_c).split(':').map(Number);
			const [endHour, endMinute] = convertTo24Hour(value).split(':').map(Number);
			startDate.setHours(startHour, startMinute, 0, 0);
			endDate.setHours(endHour, endMinute, 0, 0);

			return endDate.getTime() - startDate.getTime() >= 60 * 60 * 1000;
		});

	// Add this helper at top
	const parseTime12 = (timeStr: string): { hours: number; minutes: number } | null => {
		const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
		if (!match) return null;
		let hours = parseInt(match[1]);
		const minutes = parseInt(match[2]);
		const period = match[3].toUpperCase();
		if (period === 'PM' && hours !== 12) hours += 12;
		if (period === 'AM' && hours === 12) hours = 0;
		return { hours, minutes };
	};

	const electionNominationEndDate = Yup.string()
		.nullable()
		.when('obMeetSelection', {
			is: 'Yes',
			then: (schema) =>
				schema
					.required('Election Nomination End Date is required')
					.test('valid-date', 'Invalid date', (value) => {
						return value && !isNaN(new Date(value).getTime());
					})
					.test(
						'after-start',
						'Election Nomination End Date and Time must be after Meeting Start Date and Time',
						function (value) {
							const { startdate, start_time_c, electionNominationEndTime } = this.parent;
							if (!value || !startdate || !start_time_c || !electionNominationEndTime) return true;

							const startDate = new Date(startdate);
							const startTime = parseTime12(start_time_c);
							if (!startTime) return false;
							startDate.setHours(startTime.hours, startTime.minutes, 0, 0);

							const endDate = new Date(value);
							const endTime = parseTime12(electionNominationEndTime);
							if (!endTime) return false;
							endDate.setHours(endTime.hours, endTime.minutes, 0, 0);

							return endDate.getTime() > startDate.getTime();
						}
					)
					.test(
						'before-end',
						'Election Nomination End Date and Time must be before Meeting End Date and Time',
						function (value) {
							const { enddate, end_time_c, electionNominationEndTime } = this.parent;
							if (!value || !enddate || !end_time_c || !electionNominationEndTime) return true;

							const endMeeting = new Date(enddate);
							const endMeetingTime = parseTime12(end_time_c);
							if (!endMeetingTime) return false;
							endMeeting.setHours(endMeetingTime.hours, endMeetingTime.minutes, 0, 0);

							const nominationEnd = new Date(value);
							const nominationTime = parseTime12(electionNominationEndTime);
							if (!nominationTime) return false;
							nominationEnd.setHours(nominationTime.hours, nominationTime.minutes, 0, 0);

							return nominationEnd.getTime() < endMeeting.getTime();
						}
					),
			otherwise: (schema) => schema.nullable(),
		});

	const electionNominationEndTime = Yup.string()
		.nullable()
		.when('obMeetSelection', {
			is: 'Yes',
			then: (schema) =>
				schema
					.required('Election Nomination End Time is required')
					.test('valid-time', 'Invalid time format', (value) => value && parseTime12(value) !== null)
					.test(
						'after-start',
						'Election Nomination End Date and Time must be after Meeting Start Date and Time',
						function (value) {
							const { startdate, start_time_c, electionNominationEndDate } = this.parent;
							if (!value || !startdate || !start_time_c || !electionNominationEndDate) return true;

							const startDate = new Date(startdate);
							const startTime = parseTime12(start_time_c);
							if (!startTime) return false;
							startDate.setHours(startTime.hours, startTime.minutes, 0, 0);

							const endDate = new Date(electionNominationEndDate);
							const endTime = parseTime12(value);
							if (!endTime) return false;
							endDate.setHours(endTime.hours, endTime.minutes, 0, 0);

							return endDate.getTime() > startDate.getTime();
						}
					)
					.test(
						'before-end',
						'Election Nomination End Date and Time must be before Meeting End Date and Time',
						function (value) {
							const { enddate, end_time_c, electionNominationEndDate } = this.parent;
							if (!value || !enddate || !end_time_c || !electionNominationEndDate) return true;

							const endMeeting = new Date(enddate);
							const endMeetingTime = parseTime12(end_time_c);
							if (!endMeetingTime) return false;
							endMeeting.setHours(endMeetingTime.hours, endMeetingTime.minutes, 0, 0);

							const nominationEnd = new Date(electionNominationEndDate);
							const nominationTime = parseTime12(value);
							if (!nominationTime) return false;
							nominationEnd.setHours(nominationTime.hours, nominationTime.minutes, 0, 0);

							return nominationEnd.getTime() < endMeeting.getTime();
						}
					),
			otherwise: (schema) => schema.nullable(),
		});

	const siteName = Yup.string().required('Site Name is required');
	const glueUsedAtSite = Yup.string().required('Glue Used at Site is required');
	const siteLocation = Yup.string().required('Site Location is required');
	const gradeUsed = Yup.string().required('Grade & Brand of Glue used at Site is required');
	const contractType = Yup.string().required('Type of Contract is required');
	const contractorName = Yup.string()
		.required('Contractor Name is required')
		.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed');
	const contractorNumber = Yup.string().required('Contractor Number is required');
	const competitionReason = Yup.string().when('glueUsedAtSite', {
		is: (val: string) => val === 'Competition',
		then: () => Yup.string().required('Reason For Competition is Required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});
	const brandUsed = Yup.string().when('glueUsedAtSite', {
		is: (val: string) => val === 'Competition',
		then: () => Yup.string().required('Brand of Glue used at Site is Required').nullable(),
		otherwise: () => Yup.string().nullable(),
	});

	const secondaryCompetitionReason = Yup.array()
		.of(
			Yup.object().shape({
				id: Yup.number().required('ID is required'),
				value: Yup.string().required('Value is required'),
			})
		)
		.when('glueUsedAtSite', {
			is: (val: string) => val === 'Competition',
			then: (schema) =>
				schema.test('not-same-as-primary', 'Secondary reason cannot be the same as primary reason', function (value) {
					const { competitionReason, secondaryCompetitionReasonOther } = this.parent;
					if (!value || value.length === 0 || !competitionReason) {
						return true; // Skip validation if no secondary reason or no primary reason
					}

					// Check if any secondary reason matches the primary reason
					const hasMatchingReason = value.some((item: { value: string }) => {
						// If "Other" is selected, check the custom text value
						if (item.value === 'Other' && secondaryCompetitionReasonOther) {
							return secondaryCompetitionReasonOther === competitionReason;
						}
						// Otherwise check the direct value
						return item.value === competitionReason;
					});

					return !hasMatchingReason;
				}),
			otherwise: (schema) => schema.nullable(),
		})
		.nullable();

	const secondaryCompetitionReasonOther = Yup.string()
		.when(['secondaryCompetitionReason', 'glueUsedAtSite'], {
			is: (secondaryCompetitionReason: Array<{ value: string }> | null | undefined, glueUsedAtSite: string) => {
				return glueUsedAtSite === 'Competition' && secondaryCompetitionReason?.some((item) => item.value === 'Other');
			},
			then: () =>
				Yup.string()
					.required('Please specify other reason')
					.test('not-same-as-primary', 'Secondary reason cannot be the same as primary reason', function (value) {
						const { competitionReason } = this.parent;
						if (!value || !competitionReason) {
							return true; // Skip validation if no value or no primary reason
						}
						return value !== competitionReason;
					})
					.nullable(),
			otherwise: () => Yup.string().nullable(),
		})
		.nullable();
	const dealerName = Yup.string().required('Dealer Name is required');
	const gluePotentialOfSite = Yup.string()
		.required('Glue Potential of Site is required')
		.matches(/^\d+$/, 'Only numbers are allowed');
	const availableOtherProductsDemoed = availableOtherProductsDemoValidationSchema;
	const availableOtherProductsDiscussed = availableOtherProductsDiscussValidationSchema;
	const architect_details = Yup.array().of(accordianSchema);
	const influencer_details = Yup.array().of(accordianSchema);
	const owner_details = Yup.array().of(accordianSchema);
	const kyc_file_name = Yup.string().required();
	const feedback = Yup.array().of(
		Yup.array().of(
			Yup.object().shape({
				feedbackResponse: Yup.mixed()
					.test('conditional-required', 'This field is required', function (value) {
						const { type, validation } = this.parent;
						if (type === 'checkbox') {
							return true;
						}
						if (validation) {
							return !!value;
						}
						return true;
					})
					.test('valid-dropdown', 'Please select a valid option', function (value) {
						const { type, feedbackOptions } = this.parent;
						if (type === 'dropdown' && feedbackOptions?.length) {
							return feedbackOptions.some((option: DropdownOptions) => option.value === value);
						}
						return true;
					})
					.test('valid-number', 'Number is not valid', function (value) {
						const { type, validation } = this.parent;
						if (type === 'text' && validation !== undefined && validation === 'number' && typeof value === 'string') {
							return phoneRegExp.test(value);
						}
						return true;
					})
					.test('valid-text', 'Name is not valid', function (value) {
						const { type, validation } = this.parent;
						if (type === 'text' && validation === 'text' && typeof value === 'string') {
							return /^[A-Za-z\s]*$/.test(value);
						}
						return true;
					}),
			})
		)
	);
	const exception = Yup.array().of(
		Yup.object().shape({
			id: Yup.number(),
			productId: Yup.number(),
			feedbackQuestion: Yup.string(),
			feedbackOptions: Yup.array().of(
				Yup.object().shape({
					id: Yup.number(),
					value: Yup.string(),
				})
			),
			feedbackResponse: Yup.string()
				.required('Feedback is required')
				.test('valid-dropdown', 'Please select a valid option', function (value) {
					const { type, feedbackOptions } = this.parent;
					if (type === 'dropdown' && feedbackOptions?.length) {
						return feedbackOptions.some((option: DropdownOptions) => option.value === value);
					}
					return true;
				}),
			type: Yup.string(),
			placeHolder: Yup.string(),
		})
	);
	const name = Yup.string().required('Name is required');
	const contact = Yup.string().required('Contact number is required');
	const town = Yup.string().required('Town is required');
	const meetingVenue = Yup.string().required('Meeting Venue is required');
	const meetingType = Yup.string().required('Meeting Type is required');
	const mdi = Yup.string().required('MDI is required');
	const primaryFocusProduct = Yup.string().when('meetingType', ([meetingType], schema) => {
		if (!MEETING_HIDE_FOCUS_PRODUCT.includes(meetingType)) {
			return schema.required('Primary Focus Product is required');
		}
		return schema.notRequired();
	});
	const primaryFocusProductLcdMeets = Yup.array().when('meetingType', ([meetingType], schema) => {
		if (meetingType === LCD_MEETS_SHOP_HALL) {
			return schema.min(1, 'At least one focus product is required').required('Primary Focus Product is required');
		}
		return schema.notRequired();
	});
	const productDiscussed = Yup.string().when('meetingType', ([meetingType], schema) => {
		if (!MEETING_HIDE_FOCUS_PRODUCT.includes(meetingType)) {
			return schema.required('Products Discussed is required');
		}
		return schema.notRequired();
	});
	const meetFormat = Yup.string().required('Meet Format is required');
	const participants = Yup.string().required('Participants is required');
	const productHierarchyCode = Yup.string().required('Product Hierarchy Code is required');

	const catagories = Yup.string().required('Category is required');

	const designation = Yup.string().when('catagories', {
		is: 'Pidilite Employee',
		then: (schema) => schema.required('Designation is required'),
		otherwise: (schema) => schema.notRequired(),
	});

	const natureOfWork = Yup.string().when('catagories', {
		is: 'Helper/Junior Staff',
		then: (schema) => schema.required('Nature of Work is required'),
		otherwise: (schema) => schema.notRequired(),
	});

	const userToBeLinked = Yup.string().when('catagories', {
		is: 'Helper/Junior Staff',
		then: (schema) => schema.required('User to be linked is required'),
		otherwise: (schema) => schema.notRequired(),
	});

	const obstacleFaced = Yup.string().required('Obstacle Faced is required');
	const learningForm = Yup.string().required('Learning from in the meeting is required');

	const meeting_expenses = Yup.string().required('Meeting Expense is required');
	const food = Yup.string().required('Food Expense is required');
	const venue = Yup.string().required('Venue Expense is required');
	const gifts = Yup.string().required('Gifts Expense is required');
	const others = Yup.string().required('Others Expense is required');
	const slab = Yup.string().required();
	const address = Yup.string().required('Address is required');
	const contractorName1 = contractorNameValidation(1);
	const contractorName2 = contractorNameValidation(2);
	const contractorNumber1 = Yup.string().matches(phoneRegExp, 'Phone number is not valid').nullable();
	const contractorNumber2 = Yup.string().matches(phoneRegExp, 'Phone number is not valid').nullable();
	const productRSI = dealerVisitProductsValidationSchema;
	const activityDiscussed = dealerVisitProductsValidationSchema;

	const sku_names_c = Yup.string().required('SKU Name is required');

	const ref_lot_no_c = Yup.string().when('sub_category_defect_c', {
		is: 'Post Application',
		then: (schema) => schema.notRequired(),
		otherwise: (schema) => schema.required('Ref/Lot No is required'),
	});
	const manufactured_in_c = Yup.string().required('Manufacture date is required');
	const quantity_c = Yup.string().required('Quantity in Pieces is required');
	const customer_name_c = Yup.string().required('Customer Name is required');
	const registered_mobile_number_c = Yup.string()
		.matches(phoneRegExp, 'Number is not valid')
		.required('Customer Registered Mobile Number is required')
		.nullable();
	const type_of_complaint_c = Yup.string().required('Type of Complainant is required');
	const dealer_membership_code_c = Yup.string().required('Dealer/User Membership Code is required');
	const wss_names_c = Yup.string().required('WSS Name is required');
	const site_under_warranty_c = Yup.string().required('Site under warranty is required');
	const what_is_the_warranty_certificate_number_c = Yup.string().when('site_under_warranty_c', {
		is: 'Yes',
		then: (schema) => schema.required('What is the Warranty Certificate Number is Required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const nature_of_complaints_c = Yup.string().required('Nature of complaint is required');
	const sub_category_defect_c = Yup.string().when('nature_of_complaints_c', {
		is: 'Expired Product',
		then: (schema) => schema.notRequired(),
		otherwise: (schema) => schema.required('Sub Category/ Defect is required'),
	});

	const description_c = Yup.string()
		.trim()
		.required('Complaint Description is required')
		.max(255, 'Complaint Description should no be more than 255 characters');
	const complaint_sample_availability_c = Yup.string().required('Complaint sample availability is required');
	const sample_non_availability_reason = Yup.string().when('complaint_sample_availability_c', {
		is: 'No',
		then: (schema) => schema.required('Reason for unavailability of Sample is Required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const sample_non_availability_reason_others = Yup.string().when('sample_non_availability_reason', {
		is: 'Others',
		then: (schema) =>
			schema
				.required('Specification is Required')
				.max(255, 'Complaint Description should no be more than 255 characters'),
		otherwise: (schema) => schema.notRequired(),
	});

	const applicator_name = Yup.string().when('nature_of_complaints_c', {
		is: 'Product Application Complaint',
		then: (schema) => schema.required('Name of the Applicator/Contractor is required'),

		otherwise: (schema) => schema.notRequired(),
	});
	const stage_of_application_during_complaint_c = Yup.string().when('nature_of_complaints_c', {
		is: 'Product Application Complaint',
		then: (schema) => schema.required('Stage of application during complaint is required'),

		otherwise: (schema) => schema.notRequired(),
	});
	const application_surface_c = Yup.string().when('nature_of_complaints_c', {
		is: 'Product Application Complaint',
		then: (schema) => schema.required('Application Surface is required'),

		otherwise: (schema) => schema.notRequired(),
	});
	const area_in_sqft_c = Yup.string().when('nature_of_complaints_c', {
		is: 'Product Application Complaint',
		then: (schema) => schema.required('Area is required'),

		otherwise: (schema) => schema.notRequired(),
	});
	const observation_c = Yup.string().when('nature_of_complaints_c', {
		is: 'Product Application Complaint',
		then: (schema) =>
			schema
				.required('Observation is required')
				.max(255, 'Observation Description should no be more than 255 characters'),
		otherwise: (schema) => schema.notRequired(),
	});
	const isContractorAvailable = Yup.string().when('$config', {
		is: () => SiteLeadConfigurations.OTP_FLOW,
		then: (schema) => schema.required('Is contractor available at site is required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const isWeatherWorkGivenToJoinery = Yup.string().required('Weather work is given to a Joinery is required');
	const joineryName = Yup.string().when('isWeatherWorkGivenToJoinery', {
		is: 'Yes',
		then: (schema) =>
			schema
				.required('Joinery Name is required')
				.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed in the name'),
		otherwise: (schema) => schema.notRequired(),
	});
	const joineryNumber = Yup.string().when('isWeatherWorkGivenToJoinery', {
		is: 'Yes',
		then: (schema) => schema.required('Joinery Number is required').matches(phoneRegExp, 'Number is not valid'),
		otherwise: (schema) => schema.notRequired(),
	});
	const joineryAddress = Yup.string().when('isWeatherWorkGivenToJoinery', {
		is: 'Yes',
		then: (schema) => schema.required('Joinery Address is required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const isWorkGivenToFactory = Yup.string().when('role', {
		is: RoleType.KAE,
		then: (schema) => schema.required('Whether work is given to a Factory is required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const siteAddressFactoryName = Yup.string().when(['role', 'isWorkGivenToFactory'], {
		is: (role: string, isWorkGivenToFactory: string) => role === RoleType.KAE && isWorkGivenToFactory === 'Yes',
		then: (schema) =>
			schema
				.required('Factory Name is required')
				.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed in the name'),
		otherwise: (schema) => schema.notRequired(),
	});
	const siteAddressFactoryNumber = Yup.string().when(['role', 'isWorkGivenToFactory'], {
		is: (role: string, isWorkGivenToFactory: string) => role === RoleType.KAE && isWorkGivenToFactory === 'Yes',
		then: (schema) => schema.required('Factory Number is required').matches(phoneRegExp, 'Number is not valid'),
		otherwise: (schema) => schema.notRequired(),
	});
	const siteAddressFactoryAddress = Yup.string().when(['role', 'isWorkGivenToFactory'], {
		is: (role: string, isWorkGivenToFactory: string) => role === RoleType.KAE && isWorkGivenToFactory === 'Yes',
		then: (schema) => schema.required('Factory Address is required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const substratesCombinations = substratesValidationSchema;
	const meetingClub = meetingClubValidationSchema;
	const meetingDealer = Yup.string().when(['role', 'meetingType'], ([role, meetingType], schema) => {
		if (role === RoleType.TSI || meetingType === IsLcdWiseUserMeet) {
			return schema.required(meetingType === LCD_MEETS_SHOP_HALL ? 'Group Code is required' : 'Dealer is required');
		}
		return schema.notRequired();
	});
	const factoryName = Yup.string().required('Factory name is required');
	const factoryLocation = Yup.string().required('Factory location is required');
	const brandNoticed = Yup.string().required('Please select a valid option');
	const brand = Yup.string().when('brandNoticed', {
		is: 'Yes',
		then: (schema) => schema.required('Please select a valid option'),
		otherwise: (schema) => schema.notRequired(),
	});
	const brandOthers = Yup.string().when(['brandNoticed', 'brand'], {
		is: (brandNoticed: string, brand: string) => brandNoticed === 'Yes' && brand === 'Others',
		then: (schema) => schema.required('Brand name is required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const chargeToVisitContractor = Yup.string().required('Please select a valid option');
	const factory_visit_feedback = Yup.string().max(255, 'Observation Description should no be more than 255 characters');
	const superVisorName = Yup.string()
		.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed in the name')
		.nullable();
	const superVisorNameRequired = Yup.string()
		.required('Site In-Charge Name is required')
		.matches(/^(?!\s)(?=.*[a-zA-Z])[a-zA-Z\s.]+$/, 'Only English characters are allowed in the name');
	const siteSpecialist = Yup.string().required('Please select a valid option');
	const superVisorNumber = Yup.string().matches(phoneRegExp, 'Number is not valid').nullable();
	const superVisorNumberRequired = Yup.string()
		.required('Site In-Charge Number is required')
		.matches(phoneRegExp, 'Number is not valid');
	const competitionGlueUsedSoFar = Yup.string()
		.required('Competition glue used so far is required')
		.matches(/^\d+$/, 'Only numbers are allowed');
	const fvGlueUsedSoFar = Yup.string()
		.required('FV glue used so far is required')
		.matches(/^\d+$/, 'Only numbers are allowed');
	const noOfActiveSites = Yup.string()
		.required('Number of active sites is required')
		.matches(/^\d+$/, 'Only numbers are allowed');

	const meetingTheme = Yup.string().required('Meeting Theme is required');

	const rbdmStartdate = Yup.string()
		.required('Start date is required')
		.test('is-valid-date', 'Invalid date format', function (value) {
			if (!value) return false;
			const date = new Date(value);
			return !isNaN(date.getTime());
		})
		.test('is-future-date', 'Start date must be today or in the future', function (value) {
			if (!value) return false;
			const date = new Date(value);
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			date.setHours(0, 0, 0, 0);
			return date >= today;
		});

	const rbdmEnddate = Yup.string()
		.required('End date is required')
		.test('is-valid-date', 'Invalid date format', function (value) {
			if (!value) return false;
			const date = new Date(value);
			return !isNaN(date.getTime());
		})
		.test('is-valid-range', 'End date must be the same or later than start date', function (value) {
			const { startdate } = this.parent;
			if (startdate && value) {
				const start = new Date(startdate);
				const end = new Date(value);
				start.setHours(0, 0, 0, 0);
				end.setHours(0, 0, 0, 0);
				return end >= start;
			}
			return true;
		})
		.test('is-within-5-days', 'You can create meetings for up to 5 days only', function (value) {
			const { startdate } = this.parent;
			if (startdate && value) {
				const start = new Date(startdate);
				const end = new Date(value);
				start.setHours(0, 0, 0, 0);
				end.setHours(0, 0, 0, 0);
				const diffTime = end.getTime() - start.getTime();
				const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
				return diffDays <= 5;
			}
			return true;
		});

	const RBDMAddMeetingValidationSchema = Yup.object({
		meetingType: Yup.string().required('Meeting Type is required'),
		startdate: rbdmStartdate,
		enddate: rbdmEnddate,
		start_time_c: start_time_c,
		end_time_c: end_time_c,
		name: name,
		meetingVenue: meetingVenue,
		meetingTheme: meetingTheme,
		cmdi: Yup.string().required('CMDI is required'),
		club: Yup.string().required('Club is required'),
		RBDMclub: Yup.string().required('Club is required'),
	});
	const siteType = Yup.string().required('Site Type is required');
	const typeOfProperty = Yup.string().when(['siteType'], {
		is: (siteType: string) => siteType === SiteTypeLabel.Residential || siteType === SiteTypeLabel.Commercial,
		then: (schema) => schema.required('Type of Property is required'),
		otherwise: (schema) => schema.notRequired(),
	});
	const propertyArea = Yup.string().required('Area in Sq Ft is required');
	const siteStage = Yup.string().required('Site stage is required');
	const brandAvailable = Yup.string().required('Brand Available is required');
	const glueUsedSoFar = Yup.number().when('glueUsedAtSite', {
		is: (val: string) => val === GlueUsedLabel.Competition,
		then: () =>
			Yup.number()
				.required('Glue used so far is required')
				.max(Yup.ref('gluePotentialOfSite'), 'Glue used so far cannot be greater than Glue potential of site'),
		otherwise: () => Yup.number().notRequired(),
	});
	const conversionPotential = Yup.number().when('glueUsedAtSite', {
		is: (val: string) => val === GlueUsedLabel.Competition,
		then: () => Yup.number().required('Conversion Potential is required'),
		otherwise: () => Yup.number().notRequired(),
	});
	const siteSubStage = Yup.string().required('Site sub stage is required');
	const tentativeNextVisit = Yup.date()
		.required('Tentative next visit date is required')
		.min(today, 'Tentative next visit date must be today or in the future');
	const glueConsumed = Yup.number()
		.typeError('Only numbers are allowed')
		.required('Glue consumed is required')
		.min(0, 'Value must be positive number')
		.test(
			'glue-consumed-max',
			'Glue consumed as on date should not be greater than Fevicol business potential',
			function (value) {
				const { parent } = this;
				const fevicolBusinessPotential = parent.fevicol_business_potential_c;

				if (value && fevicolBusinessPotential && Number(value) > Number(fevicolBusinessPotential)) {
					return this.createError({
						message: 'Glue consumed as on date should not be greater than Fevicol business potential',
						path: this.path,
					});
				}
				return true;
			}
		);
	const additionalCompetitionBrand = Yup.string().required('Additional competition brand is required');
	const personAtSite = Yup.string().when('siteVisitCount', {
		is: (siteVisitCount: number) => siteVisitCount === 2,
		then: () => Yup.string().required('Person at site is required'),
		otherwise: () => Yup.string().notRequired(),
	});
	const reasonForCompetition = Yup.string().when('siteVisitCount', {
		is: (siteVisitCount: number) => siteVisitCount === 2,
		then: () => Yup.string().required('Reason for competition is required'),
		otherwise: () => Yup.string().notRequired(),
	});
	const personConvince = Yup.string().required('	person convince is required');
	const followUpDate = Yup.date().when(['personConvince', 'siteVisitCount'], {
		is: (personConvince: string, siteVisitCount: number) =>
			(personConvince === 'Yes' && siteVisitCount === 2) || (personConvince === 'No' && siteVisitCount >= 3),
		then: () =>
			Yup.date().required('Follow up date is required').min(today, 'Follow up must be today or in the future'),
		otherwise: () => Yup.date().notRequired(),
	});
	const productDemo = Yup.string().when(['personConvince', 'siteVisitCount'], {
		is: (personConvince: string, siteVisitCount: number) => personConvince === 'No' && siteVisitCount === 2,
		then: () => Yup.string().required('Product demo is required'),
		otherwise: () => Yup.string().notRequired(),
	});
	const unsuccessfulDemoReason = Yup.string().when(['personConvince', 'siteVisitCount'], {
		is: (personConvince: string, siteVisitCount: number) => personConvince === 'No' && siteVisitCount === 2,
		then: () => Yup.string().required('Unsuccessful demo reason is required'),
		otherwise: () => Yup.string().notRequired(),
	});
	const conversionVolume = Yup.number().when('personConvince', {
		is: (val: string) => val === 'Yes',
		then: () =>
			Yup.number()
				.required('Conversion volume is required')
				.min(0, 'Value must be positive')
				.test(
					'conversion-volume-max',
					'Conversion volume should not be greater than conversion potential',
					function (value) {
						const { parent } = this;
						const conversionPotential = parent.conversionPotential;
						if (value && conversionPotential && Number(value) > Number(conversionPotential)) {
							return this.createError({
								message: 'Conversion volume should not be greater than conversion potential',
								path: this.path,
							});
						}
						return true;
					}
				),
		otherwise: () => Yup.number().notRequired(),
	});
	const fevicolProduct = Yup.array().when('personConvince', {
		is: (val: string) => val === 'Yes',
		then: () =>
			Yup.array().min(1, 'At least one Fevicol product must be selected').required('Fevicol product is required'),
		otherwise: () => Yup.array().notRequired(),
	});
	const totalConversionVolume = Yup.number().when('personConvince', {
		is: (val: string) => val === 'Yes',
		then: () => Yup.number().required('Total conversion volume is required').min(0, 'Value must be positive'),
		otherwise: () => Yup.number().notRequired(),
	});

	const followUpReason = Yup.string().when(['personConvince', 'siteVisitCount'], {
		is: (personConvince: string, siteVisitCount: number) => personConvince === 'No' && siteVisitCount >= 3,
		then: () => Yup.string().required('Follow up reason is required'),
		otherwise: () => Yup.string().notRequired(),
	});

	// Update followUpDate validation for visit count >= 3
	const followUpDateForVisit3Plus = Yup.date().when(['personConvince', 'siteVisitCount'], {
		is: (personConvince: string, siteVisitCount: number) => personConvince === 'No' && siteVisitCount >= 3,
		then: () =>
			Yup.date().required('Follow up date is required').min(today, 'Follow up must be today or in the future'),
		otherwise: () => Yup.date().notRequired(),
	});

	const noOfSites = Yup.string().required('No. of active sites is required');
	const contractorPotentialPerMonth = Yup.string().required('Contractor potential per month is required');
	const assigneCmdi = Yup.string().when('role', {
		is: RoleType.BDESE,
		then: (schema) => schema.required('Please select a ss option'),
		otherwise: (schema) => schema.notRequired(),
	});

	const otherBrandName = Yup.string().when('brandAvailable', {
		is: (val: string) => val === 'Others',
		then: () => Yup.string().required('Other brand name is required'),
		otherwise: () => Yup.string().notRequired(),
	});

	const productComplaintLast1Month = Yup.string().required(
		'Please select whether the user faced any complaint in last 1 month'
	);

	const complaintProductsList = Yup.array().when('productComplaintLast1Month', {
		is: 'Yes',
		then: () =>
			Yup.array()
				.of(
					Yup.object().shape({
						id: Yup.number().required(),
						value: Yup.string().required(),
					})
				)
				.min(1, 'Please select at least one product for which the complaint was faced')
				.max(3, 'You can select maximum 3 products')
				.required('Product name is required'),
		otherwise: () => Yup.array().notRequired(),
	});

	const productComplaintDescription = Yup.array().when('productComplaintLast1Month', {
		is: 'Yes',
		then: () =>
			Yup.array()
				.of(
					Yup.object().shape({
						id: Yup.number().required(),
						value: Yup.string().required(),
					})
				)
				.min(1, 'Please select the defect or problem description')
				.required('Defect / problem description is required'),
		otherwise: () => Yup.array().notRequired(),
	});

	const customProductComplaintDescription = Yup.string().when('productComplaintDescription', {
		is: (arr: { value: string }[] | undefined) => Array.isArray(arr) && arr.some((v) => v.value === OTHERS_SPECIFY),
		then: (schema) =>
			schema
				.required('Please specify the other defect or problem description')
				.max(200, 'Description should not exceed 200 characters'),
		otherwise: (schema) => schema.notRequired(),
	});

	const meetSubCategory = Yup.string().when(['meetingType'], {
		is: (meetingType: string) => meetingType === SocialMeetType,
		then: (schema) => schema.required('Social Meet Sub-Type is required'),
		otherwise: (schema) => schema.notRequired(),
	});

	const meetingPhotos = Yup.array()
		.of(Yup.mixed())
		.when('meetingType', {
			is: (meetingType?: string) => {
				return Boolean(meetingType && linkCaptureVideosMeet.includes(meetingType));
			},
			then: (schema) => schema.min(1, 'At least one meeting image is required').required('Meeting image is required'),
			otherwise: (schema) => schema.notRequired(),
		});

	const meetingMdpClub = meetingMdpClubValidationSchema;

	return {
		primary_number,
		secondary_number,
		sites_worked,
		sites_competition,
		average_glue,
		calculated_glue,
		permanent_town,
		permanent_address,
		permanent_city,
		permanent_state,
		permanent_street,
		permanent_zipcode,
		local_address,
		local_city,
		local_state,
		local_street,
		local_zipcode,
		work_address,
		work_city,
		work_state,
		work_street,
		work_zipcode,
		document,
		document_number,
		club,
		primary_details,
		average_glue_potential,
		no_of_carpenters,
		contractor_aid,
		workshop_address,
		workshop_zipcode,
		workshop_city,
		workshop_street,
		workshop_state,
		competition_details,
		siteName,
		siteLocation,
		gradeUsed,
		contractType,
		competitionReason,
		contractorName,
		contractorNumber,
		title,
		meeting_venue_c,
		startdate,
		enddate,
		start_time_c,
		end_time_c,
		electionNominationEndDate,
		electionNominationEndTime,
		dealerName,
		gluePotentialOfSite,
		architect_details,
		influencer_details,
		owner_details,
		kyc_file_name,
		feedback,
		name,
		contact,
		town,
		meetingVenue,
		meetingTheme,
		meetingType,
		mdi,
		primaryFocusProduct,
		productDiscussed,
		meetFormat,
		participants,
		productHierarchyCode,
		catagories,
		designation,
		natureOfWork,
		userToBeLinked,
		obstacleFaced,
		learningForm,
		meeting_expenses,
		food,
		venue,
		gifts,
		others,
		slab,
		exception,
		activityDiscussed,
		productRSI,
		address,
		rbdmTown,
		contractorName1,
		contractorName2,
		contractorNumber1,
		contractorNumber2,
		sku_names_c,
		ref_lot_no_c,
		manufactured_in_c,
		quantity_c,
		customer_name_c,
		registered_mobile_number_c,
		type_of_complaint_c,
		dealer_membership_code_c,
		wss_names_c,
		site_under_warranty_c,
		what_is_the_warranty_certificate_number_c,
		nature_of_complaints_c,
		sub_category_defect_c,
		description_c,
		complaint_sample_availability_c,
		sample_non_availability_reason,
		sample_non_availability_reason_others,
		applicator_name,
		stage_of_application_during_complaint_c,
		application_surface_c,
		area_in_sqft_c,
		observation_c,
		factory_address,
		factory_city,
		factory_state,
		factory_zipcode,
		isContractorAvailable,
		isWeatherWorkGivenToJoinery,
		joineryName,
		joineryNumber,
		joineryAddress,
		isWorkGivenToFactory,
		siteAddressFactoryName,
		siteAddressFactoryNumber,
		siteAddressFactoryAddress,
		substratesCombinations,
		glueUsedAtSite,
		secondaryCompetitionReason,
		secondaryCompetitionReasonOther,
		meetingClub,
		meetingDealer,
		competitionConsumption,
		factoryName,
		factoryLocation,
		brandNoticed,
		brand,
		chargeToVisitContractor,
		brandOthers,
		factory_visit_feedback,
		siteSpecialist,
		superVisorNumber,
		superVisorName,
		superVisorNumberRequired,
		superVisorNameRequired,
		availableOtherProductsDemoed,
		availableOtherProductsDiscussed,
		competitionGlueUsedSoFar,
		fvGlueUsedSoFar,
		noOfActiveSites,
		RBDMAddMeetingValidationSchema,
		siteType,
		typeOfProperty,
		propertyArea,
		siteStage,
		brandAvailable,
		glueUsedSoFar,
		conversionPotential,
		siteSubStage,
		tentativeNextVisit,
		glueConsumed,
		additionalCompetitionBrand,
		personAtSite,
		reasonForCompetition,
		personConvince,
		followUpDate,
		productDemo,
		unsuccessfulDemoReason,
		conversionVolume,
		fevicolProduct,
		totalConversionVolume,
		noOfSites,
		contractorPotentialPerMonth,
		assigneCmdi,
		followUpReason,
		followUpDateForVisit3Plus,
		otherBrandName,
		productComplaintLast1Month,
		complaintProductsList,
		productComplaintDescription,
		customProductComplaintDescription,
		meetSubCategory,
		meetingPhotos,
		primaryFocusProductLcdMeets,
		secondary_club,
		brandUsed,
		meetingMdpClub,
		workshop_checkbox,
		factory_checkbox,
		interior_work,
		what_kind_of_jobs_do_you_undertake,
		work_do_you_generally_undertake,
		monthlyaverageconsumptionfhi_c,
		enable_carpenter_option,
		boss_name,
		boss_mobile,
	};
};

export default useValidationFields;
